import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigService } from '@frontend/vanilla/core';

@LazyClientConfig({ key: 'csBetMGMOriginals', product: ClientConfigProductName.CASINO })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: betMGMOriginalsClientConfigFactory,
})
export class BetMGMOriginalsClientConfig {
    enabledBetMGMOriginals: boolean;
    originalsExpiryDateFormat: string;
    betmgmOriginalsConfigurations: betmgmOriginalsSitecoreData;
}

export interface betmgmOriginalsSitecoreData {
    readonly AditionalInformation: string;
    readonly BackGroundImage: string;
    readonly BeforeOptInContent: string;
    readonly Days: string;
    readonly Description: string;
    readonly DurationText: string;
    readonly BonusIcon: string;
    readonly GreenTick: string;
    readonly HeaderTextcolour: string;
    readonly HeaderTitleText: string;
    readonly HedearTextSize: string;
    readonly Hours: string;
    readonly IconContent: string;
    readonly Minutes: string;
    readonly OptedInText: string;
    readonly OptinText: string;
    readonly OverlayHeaderButtonText: string;
    readonly OverlayHeaderText: string;
    readonly PrizeText: string;
    readonly PrizeValue: string;
    readonly SeeDetailsDesc: string;
    readonly SeeDetailsLastPrize: string;
    readonly SeeDetailsText: string;
    readonly SubCategoryPill: string;
    readonly SubDetailsHeaderText: string;
    readonly SubDetailsText1: string;
    readonly SubDetaisText2: string;
    readonly CategoryBackgroundImage: string;
    readonly TicketIcon: string;
    readonly TicketInfo: string;
    readonly TicketTextDetails: string;
    readonly TimeTextDetails: string;
    readonly TimeZoneText: string;
    readonly TimerIcon: string;
    readonly ViewDetailsText: string;
    readonly ViewGamesText: string;
    readonly TimerCount: number;
    readonly Seconds: string;
    readonly SourceType: string;
    readonly SourceId: string;
    readonly HeaderTitleSubText: string;
    readonly MobileBackGroundImage: string;
    readonly MobileCategoryBackgroundImage: string;
    readonly ViewDetailsUrl: string;
    readonly TimerExpiryDate: string;
}

export function betMGMOriginalsClientConfigFactory(service: LazyClientConfigService) {
    return service.get(BetMGMOriginalsClientConfig);
}
